import s from './Preloader.module.scss';
import {FuelCanisterIcon} from "@/app/[locale]/common/assets/FuelCanisterIcon/FuelCanisterIcon";

export const Preloader = () => {
    return (
        <div className={s.loader}>
            <div className={s.loader_iconContainer}>
                <FuelCanisterIcon/>
            </div>
        </div>
    );
};